import * as React from "react";
import TankSidebarRate from "./TankSidebarRate/TankSidebarRate";
import {toRoman, toEraString} from "../../helpers/helpers";

export default function TankSidebar() {
    const currency = {
        GOLD: "gold",
        SILVER: "silver"
    };

    const locs =  {
        MATCHMAKING: gettext("Matchmaking"),
        COST: gettext("Cost"),
        BATTLE_EARN_RATE: gettext("Battle earn rate"),
        PACKAGE_SELECTOR: gettext("Select Package"),
        VEHICLE_SUMMARY: gettext("Vehicle Summary"),
        CURRENT_CONFIGURATION: gettext("Current Configuration"),
        SILVER_EARN_RATE: gettext("Silver Earn Rate"),
        XP_EARN_RATE: gettext("Xp Earn Rate"),
        FREE_XP_EARN_RATE: gettext("Free Xp Earn Rate"),
        CREW_XP_RATE: gettext("Crew Xp Rate"),
        UP_TO_TIER: gettext("Up to Tier"),
        BASE_SILVER_EARN_RATE: gettext("Base silver earn rate"),
        BASE_XP_EARN_RATE: gettext("Base Xp earn rate"),
        BASE_CREW_XP_RATE: gettext("Base crew xp rate"),
        BASE_FREE_XP_EARN_RATE: gettext("Base free xp earn rate"),
        ERA: gettext("Era"),
    };

    let TANK_PRICE_CLASS = "tank-stat_price";
    let currencyChoice = currency.SILVER;
    let battleLevel = vehicle.data.battle_level_max;
    let tankEra = vehicle.info.era;
    let game_mode = vehicle.info.game_mode;

    const baseBonus = 100;
    const baseFreeBonus = 5;
    const silverBonus = (vehicle.data.silver_bonus && vehicle.data.silver_bonus > 0) ? Math.round(vehicle.data.silver_bonus*100) : 0;
    const xpBonus = vehicle.data.xp_bonus ? Math.round(vehicle.data.xp_bonus*100) : 0;
    const freeXpBonus = vehicle.data.free_xp_bonus ? Math.round(vehicle.data.free_xp_bonus*100) : 0;
    const crewBonus = vehicle.data.crew_bonus ? Math.round(vehicle.data.crew_bonus*100): 0;

    const battleLevelCWMapping = {
        12: gettext("Post War"),
        13: gettext("Escalation"),
        14: gettext("Détente"),
    }

    if (vehicle.info.is_premium) {
        currencyChoice = currency.GOLD;
        TANK_PRICE_CLASS += " " + TANK_PRICE_CLASS + "__premium";
    }

    return (
        <div className="tank-stat_side-content">
            <div className="tank-stat_side-cost">
                <div className="tank-stat_title">
                    <h3>{locs.COST}</h3>
                </div>
                <div className="tank-stat_body">
                    <div className={TANK_PRICE_CLASS}>
                        <span className="svg-icon js-svg-icon"
                          data-src={ STATIC_URL +"portal/img/svg-icons/currency/" + currencyChoice + ".svg"}>
                        </span>
                        <span>{vehicle.info.price.toLocaleString()}</span>
                    </div>
                    <div className="tank-stat_exp">
                        <span className="svg-icon js-svg-icon"
                              data-src={STATIC_URL + "portal/img/svg-icons/currency/exp.svg"}>
                        </span>
                        <span>{vehicle.info.xp_cost.toLocaleString()}</span>
                    </div>
                </div>
            </div>
            <div className="tank-stat_earn-rate">
                <div className="tank-stat_title">
                    <h3>{locs.BATTLE_EARN_RATE}</h3>
                </div>
                <div className="tank-stat_body">
                    <span>{locs.SILVER_EARN_RATE}
                        {
                            vehicle.info.is_premium && silverBonus > 0 &&
                            <span className="svg-icon js-svg-icon"
                                  data-src={ STATIC_URL + "portal/img/svg-icons/configuration/premium.svg"}>
                            </span>
                        }
                    </span>
                    <span className={"tank-stat_text"  + (silverBonus > 0 ? " tank-stat_text__premium": "")}
                          id="js-silver-rate">{silverBonus + baseBonus}%</span>
                    <TankSidebarRate linkedId="js-silver-rate" baseRateText={locs.BASE_SILVER_EARN_RATE}
                                 bonusRate={silverBonus} baseRate={baseBonus}/>
                </div>
                <div className="tank-stat_body">
                    <span>{locs.XP_EARN_RATE}
                        {
                            vehicle.info.is_premium && xpBonus > 0 &&
                            <span className="svg-icon js-svg-icon"
                                  data-src={ STATIC_URL + "portal/img/svg-icons/configuration/premium.svg"}>
                            </span>
                        }
                    </span>
                    <span className={"tank-stat_text"  + (xpBonus > 0 ? " tank-stat_text__premium": "")}
                          id="js-xp-bonus">{xpBonus + baseBonus}%</span>
                    <TankSidebarRate linkedId="js-xp-bonus" baseRateText={locs.BASE_XP_EARN_RATE}
                                 bonusRate={xpBonus} baseRate={baseBonus}/>
                </div>
                <div className="tank-stat_body">
                    <span>{locs.FREE_XP_EARN_RATE}
                         {
                            vehicle.info.is_premium && (freeXpBonus - baseFreeBonus) > 0 &&
                            <span className="svg-icon js-svg-icon"
                                  data-src={ STATIC_URL + "portal/img/svg-icons/configuration/premium.svg"}>
                            </span>
                        }
                    </span>
                    <span className={"tank-stat_text"  + ((freeXpBonus - baseFreeBonus) > 0 ? " tank-stat_text__premium": "")}
                          id="js-free-xp-bonus">{freeXpBonus}%</span>
                    <TankSidebarRate linkedId="js-free-xp-bonus" baseRateText={locs.BASE_FREE_XP_EARN_RATE}
                                 bonusRate={freeXpBonus - baseFreeBonus} baseRate={baseFreeBonus}/>
                </div>
                <div className="tank-stat_body">
                    <span>{locs.CREW_XP_RATE}
                        {
                            vehicle.info.is_premium && crewBonus > 0 &&
                            <span className="svg-icon js-svg-icon"
                                  data-src={ STATIC_URL + "portal/img/svg-icons/configuration/premium.svg"}>
                            </span>
                        }
                    </span>
                    <span className={"tank-stat_text"  + (crewBonus > 0 ? " tank-stat_text__premium": "")}
                          id="js-crew-rate">{crewBonus + baseBonus}%</span>
                    <TankSidebarRate linkedId="js-crew-rate" baseRateText={locs.BASE_CREW_XP_RATE}
                                 bonusRate={crewBonus} baseRate={baseBonus}/>
                </div>
            </div>
            <div className="tank-stat_matchmaking">
                <div className="tank-stat_title">
                    <h3>{locs.MATCHMAKING}</h3>
                </div>
                <div className="tank-stat_body">
                    <p>{game_mode == 'coldwar' ? locs.ERA : locs.UP_TO_TIER}</p>
                    <span className="tank-stat_text">{
                        game_mode == 'coldwar' ? battleLevelCWMapping[battleLevel] : toRoman(battleLevel)
                    }</span>
                </div>
            </div>
        </div>
    );
}
